<template>
  <iframe
    v-if="jotFormID"
    :id="jotFormElementID"
    allowtransparency="true"
    allowfullscreen="true"
    allow="geolocation; microphone; camera"
    :src="`https://form.jotform.com/${jotFormID}?${prefillFields}`"
    frameborder="0"
    :style="`
      min-width: 100%;
      height:${iframeHeight}px;
      border:none;`"
    scrolling="no"
  >
  </iframe>
</template>

<script>
import Vue from "vue";
export default {
  props: ["jotFormID"],
  data() {
    return {
      Account: null,
      formIframe: null,
      iframeHeight: 640,
      jotFormElementID: null,
      prefillFields: ''
    };
  },
  async created() {
    this.isJotFormLoading = true;
    this.jotFormElementID = "JotFormIFrame-" + this.jotFormID;
    try {
      let acctRes = fetch(
        Vue.config.API_ENDPOINT + "Account/Self",
        {
          method: "get",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      let prefillRes = fetch(
        Vue.config.API_ENDPOINT + "CMS/GetJotFormPrefills/" + this.jotFormID,
        {
          method: "get",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      let acctJson = await(await acctRes).json();
      this.Account = acctJson.raw;
      console.log("this.Account => ", this.Account);

      let jotFormPrefills = await(await prefillRes).json();
      console.log("jotFormPrefills => ", jotFormPrefills);

      var organizationName =
        this.Account.accountType === 1
          ? this.Account.primaryContact.firstName +
            " " +
            this.Account.primaryContact.lastName +
            " " +
            this.Account.primaryContact.suffix
          : this.Account.primaryContact.legalName;

      let preFillArray = [];
      for (let field of jotFormPrefills) {
        console.log("jotFormPrefills => field", field);
        if (field.valueType == "CONSTANT") {
          preFillArray.push( field.fieldName + "=" + field.value);
        } else if (field.fieldName === "iframeHeight") {
          this.iframeHeight = field.value;
        } else if (field.value === "organizationName") {
          preFillArray.push(field.fieldName + "=" + organizationName);
        } else {
          let elements = field.value.split(".");
          // let valueP = elements.reduce(
          //   (v, e) => (v[e] === undefined ? undefined : v[e]),
          //   this.Account
          // );

          console.log("using reduce");
          //console.log(valueP);
          console.log(elements);
          let value = this.Account;
          for (let key of elements)
            if (value[key] !== undefined) value = value[key];
            else {
              value = null;
              break;
            }
          console.log(value);

          if (value != null) preFillArray.push(field.fieldName + "=" + value);
        }
      }
      console.log(preFillArray);
      this.prefillFields = preFillArray.join("&");
      console.log(this.prefillFields);
    } catch (ex) {
      console.log(ex);
    }
  },
  methods: {
    ShowJotForm() {
      var _this = this;
      var ifr = document.getElementById(this.jotFormElementID);
      if (window.location.href && window.location.href.indexOf("?") > -1) {
        var get = window.location.href.substr(
          window.location.href.indexOf("?") + 1
        );
        if (ifr && get.length > 0) {
          var src = ifr.src;
          src = src.indexOf("?") > -1 ? src + "&" + get : src + "?" + get;
          ifr.src = src;
        }
      }
      window.handleIFrameMessage = function (e) {
        if (typeof e.data === "object") {
          return;
        }
        var args = e.data.split(":");
        var iframe = null;
        if (args.length > 2) {
          iframe = document.getElementById(
            "JotFormIFrame-" + args[args.length - 1]
          );
        } else {
          iframe = document.getElementById("JotFormIFrame");
        }
        if (!iframe) {
          return;
        }
        switch (args[0]) {
          case "scrollIntoView":
            iframe.scrollIntoView();
            break;
          case "setHeight":
            iframe.style.height = args[1] + "px";
            break;
          case "collapseErrorPage":
            if (iframe.clientHeight > window.innerHeight) {
              iframe.style.height = window.innerHeight + "px";
            }
            break;
          case "reloadPage":
            window.location.reload();
            break;
          case "loadScript":
            var src = args[1];
            if (args.length > 3) {
              src = args[1] + ":" + args[2];
            }
            var script = document.createElement("script");
            script.src = src;
            script.type = "text/javascript";
            document.body.appendChild(script);
            break;
          case "exitFullscreen":
            if (window.document.exitFullscreen)
              window.document.exitFullscreen();
            else if (window.document.mozCancelFullScreen)
              window.document.mozCancelFullScreen();
            else if (window.document.mozCancelFullscreen)
              window.document.mozCancelFullScreen();
            else if (window.document.webkitExitFullscreen)
              window.document.webkitExitFullscreen();
            else if (window.document.msExitFullscreen)
              window.document.msExitFullscreen();
            break;
        }
        var isJotForm = e.origin.indexOf("jotform") > -1 ? true : false;
        if (
          isJotForm &&
          "contentWindow" in iframe &&
          "postMessage" in iframe.contentWindow
        ) {
          var urls = {
            docurl: encodeURIComponent(document.URL),
            referrer: encodeURIComponent(document.referrer),
          };
          iframe.contentWindow.postMessage(
            JSON.stringify({ type: "urls", value: urls }),
            "*"
          );
        }
      };
      if (window.addEventListener) {
        window.addEventListener("message", handleIFrameMessage, false);
      } else if (window.attachEvent) {
        window.attachEvent("onmessage", handleIFrameMessage);
      }
      this.isJotFormLoading = false;
    },
  },
  mounted() {
    this.ShowJotForm();
  },
};
</script>



// WEBPACK FOOTER //
// JotformEmbed.vue?52f015cc